import { render, staticRenderFns } from "./TabComponent.vue?vue&type=template&id=65157068&scoped=true&"
import script from "./TabComponent.vue?vue&type=script&lang=js&"
export * from "./TabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65157068",
  null
  
)

export default component.exports